// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewMessagesCount_newMessagesCount__pEoxB {
  flex-shrink: 0;
  margin-left: 4px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: #4778EE;
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #FFFFFF;
  border-radius: 9px;
  transition: 0.3s all;
}
.NewMessagesCount_newMessagesCount__muted__QvURc {
  background: #8E8E93;
}
.NewMessagesCount_newMessagesCount__withBorder__dv75i {
  border: 1px solid white;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/NewMessagesCount/NewMessagesCount.module.scss"],"names":[],"mappings":"AAAA;EAGE,cAAA;EAEA,gBAAA;EACA,eALS;EAMT,YANS;EAOT,cAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EAEA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;EAEA,oBAAA;AAJF;AAME;EACE,mBAAA;AAJJ;AAOE;EACE,uBAAA;AALJ","sourcesContent":[".newMessagesCount {\n  $height: 18px;\n\n  flex-shrink: 0;\n\n  margin-left: 4px;\n  min-width: $height;\n  height: $height;\n  padding: 0 4px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  background: #4778EE;\n\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 16px;\n  letter-spacing: 0.4px;\n  color: #FFFFFF;\n  border-radius: $height / 2;\n\n  transition: 0.3s all;\n\n  &__muted {\n    background: #8E8E93;\n  }\n\n  &__withBorder {\n    border: 1px solid white;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"newMessagesCount": `NewMessagesCount_newMessagesCount__pEoxB`,
	"newMessagesCount__muted": `NewMessagesCount_newMessagesCount__muted__QvURc`,
	"newMessagesCount__withBorder": `NewMessagesCount_newMessagesCount__withBorder__dv75i`
};
export default ___CSS_LOADER_EXPORT___;
